import {
  Field,
  Textarea,
} from '@lightspeed/unified-components-helios-theme/react'
import { T, useT } from '@transifex/react'
import React from 'react'
import { HasCCErrorMessage } from '../../../../shared/has-cc-error-message/HasCCErrorMessage'
import {
  LineItemFulfilmentNoteProps,
  useLineItemFulfilmentNoteModel,
} from './useLineItemFulfilmentNoteModel'

export const TContext = 'Line item fulfilment tab'

export const LineItemFulfilmentNote: React.FC<LineItemFulfilmentNoteProps> = props => {
  const t = useT()
  const model = useLineItemFulfilmentNoteModel(props)
  const errorMessageSlot = (
    <span className="flex flex-col gap-1">
      {model.noteTooLong && model.shouldShowCount && (
        <span>{model.characterCountMessage}</span>
      )}
      {model.hasCreditCard && <HasCCErrorMessage />}
    </span>
  )

  return (
    <div className="uc-base">
      <Field
        invalid={model.noteTooLong || model.hasCreditCard}
        labelSlot={
          <span className="typography-body-sm-emphasized">
            <T _str="Fulfillment Note" _context={TContext} />
          </span>
        }
        descriptionSlot={
          <T
            _str="Items that require fulfillment share this note"
            _context={TContext}
          />
        }
        errorMessageSlot={
          model.noteTooLong || model.hasCreditCard
            ? errorMessageSlot
            : undefined
        }
        hintSlot={
          model.shouldShowCount && !model.noteTooLong
            ? model.characterCountMessage
            : undefined
        }
      >
        <Textarea
          customClasses={{
            statusIcon: 'items-center pt-0',
          }}
          data-testid="fulfilment-note"
          disabled={!!props.isDisabled}
          invalid={model.noteTooLong || model.hasCreditCard}
          onChange={props.onChange}
          placeholder={t('Enter a fulfillment note', { _context: TContext })}
          value={props.note}
          size="small"
        />
      </Field>
    </div>
  )
}
